import { render, staticRenderFns } from "./dataForm.vue?vue&type=template&id=071570bf&scoped=true"
import script from "./dataForm.vue?vue&type=script&lang=js"
export * from "./dataForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071570bf",
  null
  
)

export default component.exports